export const defaultState = "Input";

const selectedTab = (state = defaultState, action) => {
  switch (action.type) {
    case "FETCH_HASHTAGS_SUCCESS":
      return "Results";
    case "CHANGE_TAB":
      return action.tab;
    default:
      return state;
  }
};

export default selectedTab;



// WEBPACK FOOTER //
// ./src/reducers/selectedTab.js